import { render } from "./ActivityReport.vue?vue&type=template&id=edd6f000&ts=true"
import script from "./ActivityReport.vue?vue&type=script&lang=ts"
export * from "./ActivityReport.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/Medix_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__